/**
 * Temas de la aplicación.
 *
 * Un tema es un bloque de variables en `themes.css`: no hay nada que tocar en
 * los componentes, que ya leen esas variables. Para añadir uno, se agrega aquí
 * su entrada y allá su bloque `[data-theme='…']`.
 *
 * Los identificadores de los oscuros empiezan por `oscuro`, y de eso depende un
 * selector de `themes.css` que ajusta lo que el CSS heredado deja claro.
 */
export interface Tema {
  id: string;
  nombre: string;
  /** Qué aporta, para el selector. */
  detalle: string;
  /** Si pinta la interfaz en oscuro; el selector los agrupa aparte. */
  oscuro?: boolean;
}

export const TEMAS: Tema[] = [
  {
    id: 'corporativo',
    nombre: 'Corporativo',
    detalle: 'Los colores de siempre, barra lateral oscura.',
  },
  {
    id: 'claro',
    nombre: 'Claro',
    detalle: 'Claro y luminoso.',
  },
  {
    id: 'contraste',
    nombre: 'Alto contraste',
    detalle: 'Texto y bordes más marcados.',
  },
  {
    id: 'sepia',
    nombre: 'Descanso de vista',
    detalle: 'Fondo cálido, sin blancos puros.',
  },
  {
    id: 'gloria',
    nombre: 'Gloria',
    detalle: 'Con el rojo corporativo.',
  },
  {
    id: 'oscuro',
    nombre: 'Oscuro',
    detalle: 'Para trabajar con poca luz.',
    oscuro: true,
  },
  {
    id: 'oscuro-suave',
    nombre: 'Oscuro suave',
    detalle: 'Gris azulado, menos contraste.',
    oscuro: true,
  },
];

export const TEMA_POR_DEFECTO = TEMAS[0].id;

/**
 * Dónde se guarda el tema, en el almacenamiento del navegador -no en el de la
 * sesión-, así que sobrevive a cerrar sesión y a cerrar el navegador.
 *
 * Cada persona tiene su clave: en un equipo compartido, el tema de una no le
 * cambia la pantalla a la otra. Antes de iniciar sesión no hay usuario, y se
 * usa la clave general, que guarda el último tema elegido en ese equipo.
 */
export const CLAVE_TEMA = 'sre.theme';

export const claveDeTema = (usuario?: string | null): string =>
  usuario ? `${CLAVE_TEMA}.${usuario}` : CLAVE_TEMA;
